import { render, staticRenderFns } from "./art_work.vue?vue&type=template&id=19e6cc44&"
import script from "./art_work.vue?vue&type=script&lang=js&"
export * from "./art_work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports